import { render, staticRenderFns } from "./Loanable.vue?vue&type=template&id=4ae4f02b&scoped=true&"
import script from "./Loanable.vue?vue&type=script&lang=js&"
export * from "./Loanable.vue?vue&type=script&lang=js&"
import style0 from "./Loanable.vue?vue&type=style&index=0&id=4ae4f02b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4f02b",
  null
  
)

export default component.exports